__turbopack_context__.v({
  "container": "video-player-module__dcw4dG__container",
  "containerPhone": "video-player-module__dcw4dG__containerPhone",
  "phoneFrame": "video-player-module__dcw4dG__phoneFrame",
  "phoneFrameSvg": "video-player-module__dcw4dG__phoneFrameSvg",
  "phoneScreen": "video-player-module__dcw4dG__phoneScreen",
  "playButton": "video-player-module__dcw4dG__playButton",
  "playIcon": "video-player-module__dcw4dG__playIcon",
  "poster": "video-player-module__dcw4dG__poster",
  "posterContainer": "video-player-module__dcw4dG__posterContainer",
  "posterPhone": "video-player-module__dcw4dG__posterPhone",
  "videoEmbed": "video-player-module__dcw4dG__videoEmbed",
  "videoEmbedPhone": "video-player-module__dcw4dG__videoEmbedPhone",
  "videoWrapper": "video-player-module__dcw4dG__videoWrapper",
  "videoWrapperPhone": "video-player-module__dcw4dG__videoWrapperPhone",
});
